import { Link } from "@tanstack/react-router";
import { Clock, MapPin, Phone } from "lucide-react";

import { servicePages } from "@/data/pages";
import { business, fullAddress } from "@/lib/business";

export function Footer() {
  const destaque = servicePages.slice(0, 8);
  const bairros = servicePages.filter((page) => page.category === "bairro");
  const produtos = servicePages.filter((page) => page.category === "produto").slice(0, 8);

  return (
    <footer className="mt-20 bg-surface text-surface-foreground">
      <div className="container-page grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <h2 className="font-display text-2xl text-gold">Chavel</h2>
          <p className="mt-1 text-sm opacity-80">Chaveiro em Betim desde {business.since}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex gap-2">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <span>{fullAddress}</span>
            </li>
            <li className="flex gap-2">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <a href={`tel:${business.phoneRaw}`} className="hover:underline">
                {business.phone}
              </a>
            </li>
            <li className="flex gap-2">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <span>Seg a sex 08h–18h • Sáb 08h–13h • Emergência 24h</span>
            </li>
          </ul>
        </div>

        <FooterList title="Serviços mais procurados" items={destaque} />
        <FooterList title="Atendimento por bairro" items={bairros} />
        <FooterList title="Fechaduras e portões" items={produtos} />
      </div>

      <div className="border-t border-white/10">
        <div className="container-page flex flex-col gap-2 py-5 text-xs opacity-80 md:flex-row md:items-center md:justify-between">
          <div className="space-y-1">
            <p>© {new Date().getFullYear()} {business.name}. Todos os direitos reservados.</p>
            <p>
              Criado por{" "}
              <a
                href="https://wa.me/5531992020036?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20Chavel%20e%20quero%20falar%20sobre%20cria%C3%A7%C3%A3o%20de%20sites."
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold uppercase text-gold hover:underline"
              >
                Criar Solutions
              </a>
            </p>
          </div>
          <div className="flex gap-4">
            <Link to="/servicos" className="hover:underline">Todos os serviços</Link>
            <Link to="/blog" className="hover:underline">Blog</Link>
            <Link to="/contato" className="hover:underline">Contato</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterList({ title, items }: { title: string; items: { slug: string; keyword: string }[] }) {
  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-wide text-gold">{title}</h3>
      <ul className="mt-4 space-y-2 text-sm">
        {items.map((item) => (
          <li key={item.slug}>
            <Link to="/$slug" params={{ slug: item.slug }} className="opacity-85 hover:text-gold hover:opacity-100">
              {item.keyword}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
